import { Link } from 'react-router-dom'
import { accountPaths } from '@/routing/paths'
import { InlineTextButton } from '@/components/inline-text-button/InlineTextButton'

export type OcrQuotaActionProps = {
  onActivateSubscription?: () => void
  onContactSupport: () => void
}

/** The same resolution paths in the compact notice and the detailed usage view. */
export function OcrQuotaActions({ onActivateSubscription, onContactSupport, showUsage = false }: OcrQuotaActionProps & { showUsage?: boolean }) {
  const linkClassName =
    'rounded font-medium text-text-link underline underline-offset-2 hover:text-link-text-hover focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-link-focus-outline'

  return (
    <div className="flex flex-wrap items-center gap-x-3 gap-y-2">
      {onActivateSubscription && (
        <>
          <InlineTextButton onClick={onActivateSubscription}>Activate Subscription</InlineTextButton>
          <span aria-hidden="true" className="hidden text-brand-neutral-400 sm:inline">
            |
          </span>
        </>
      )}
      <InlineTextButton onClick={onContactSupport}>Contact Support</InlineTextButton>
      {showUsage && (
        <>
          <span aria-hidden="true" className="hidden text-brand-neutral-400 sm:inline">
            |
          </span>
          <Link className={linkClassName} to={accountPaths.usage}>
            View Usage
          </Link>
        </>
      )}
    </div>
  )
}
